'use strict';

var lowlight = require('lowlight');

var createPlugin = require('./core');

module.exports = createPlugin(lowlight);